export const todayCalculator = () => {
    const today = new Date()

    const year = today.getFullYear()
    const month = today.getMonth() + 1
    const day = today.getDate()

    return [year, month, day]
}

export const paddedCalculator = (data) => {
    return String(data).padStart(2, '0')
}